<template>
  <div class="col backgroundForm">
    <div class="col col-md-6 offset-md-3">
      <div class="alert alert-danger" role="alert">
        <h4 class="alert-heading">Verificacion de Vigencia de Matriculas</h4>
        <p>Indique su {{ searchTypeR }}</p>
        <hr>
      </div>
      <form @submit.prevent="searchBoat">
        <div class="btn-group btn-group-toggle" data-toggle="buttons">
          <label class="btn btn-info active" @click="mViewSearch">
            <input
              class="form-check-input"
              type="radio"
              name="exampleRadios"
              id="exampleRadios1"
              v-model="optionSearchR"
              value="enrollment"
              checked
            > Nombre
          </label>
          <label class="btn btn-info" @click="mViewSearch">
            <input
              class="form-check-input"
              type="radio"
              name="exampleRadios"
              id="exampleRadios2"
              v-model="optionSearchR"
              value="name"
            > Matricula
          </label>
        </div>

        <div class="form-group">
          <label for="nombreEmbarcacion">{{ searchTypeR }}</label>
          <input
            type="text"
            class="form-control"
            id="enrollment_boat_r"
            v-model="enrollment_boat_r"
            :placeholder="searchTypeR"
            autocomplete="off"
          >
          <small id="enrollmentHelp" class="form-text text-muted">Teclee {{ searchTypeR }}</small>
        </div>
        <button class="btn btn-lg btn-outline-primary col col-md-4 offset-md-4">Buscar</button>
      </form>
    </div>
    <br>
    <br>
    <transition name="bounce">
      <div class="col-12 col-md-10 offset-md-1 table-responsive" v-if="statusSearchR">
        <table class="table table-striped">
          <thead class="thead-dark">
            <tr>
              <th scoped="col">#</th>
              <th scoped="col">Nombre Embarcacion</th>
              <th scoped="col">Tipo</th>
              <th scoped="col">Matricula</th>
              <th scoped="col">Caracteristicas</th>
              <th scoped="col">Fotografias</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(boat, index) in boatsR" :key="boat.id">
              <td>{{ index+1 }}</td>
              <td>{{ boat.name_boat }}</td>
              <td>{{ boat.detail_boat }}</td>
              <td v-if="boat.enrollment">{{ boat.enrollment }}</td>
              <td v-if="boat.enrollment_old">{{ boat.enrollment_old }}</td>
              <td align="center">
                <button
                  class="btn btn-outline-warning"
                  data-toggle="modal"
                  @click="mShowBoat(boat)"
                >
                  <font-awesome-icon icon="folder-open"/>
                </button>
              </td>
              <td align="center">
                <button class="btn btn-outline-success" @click="mCallPhotos(boat)">
                  <font-awesome-icon icon="images"/>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </transition>
    <modal-loading :id-modal="idModalL" :title="modalLoadTitle" :status-send="sendRequest"></modal-loading>
    <modal-boat-data
      :name-ship="nameBoat"
      :idModalBoatData="idModalBoatData"
      :boat="boatActive"
      :boat-image="bImage"
      :owner="ownerDetail"
    ></modal-boat-data>
    <modal-photos-boat
      :id-modal-boat-gallery="idModalPhotos"
      :photos="bImages"
      :name-ship="nameBoat"
    ></modal-photos-boat>
  </div>
</template>
<script>
import Vue from "vue";
import axios from "axios";
import qs from "qs";

import modalLoading from "../modal/modalLoading";
import modalBoatData from "./ModalBoatData";
import modalPhotosBoat from "./ModalPhotosBoat";

export default {
  name: "search-boat-validate",
  data() {
    return {
      idModalL: "idLoadingM",
      idModalPhotos: "modalPhotos",
      modalLoadTitle: "Solicitando",
      sendRequest: true,
      statusSearchR: false,
      enrollment_boat_r: null,
      boatsR: [],
      activeEngineR: {},
      activeWonerR: [],
      optionSearchR: "name",
      modalLoadTitle: "Solicitando",
      sendRequest: true,
      nameBoat: null,
      ownerDetail: {},
      idModalBoatData: "idBoatDetail",
      boatActive: {},
      bImages: [],
      bImage: {}
    };
  },
  computed: {
    searchTypeR() {
      switch (this.optionSearchR) {
        case "name":
          return "Nombre de la Nave";
          break;

        case "enrollment":
          return "Matricula de la Nave";
          break;
      }
    },
    viewSearch() {
      switch (this.optionSearchR) {
        case "name":
          this.vSearch = true;
          break;

        case "enrollment":
          this.vSearch = false;
          break;
      }
      return this.vSearch;
    },
    cSessionUser() {
      return this.$store.getters.getUserState;
    }
  },
  methods: {
    searchBoat() {
      this.boatsR = [];
      this.statusSearchR = false;
      if (this.enrollment_boat_r) {
        axios
          // .get(`searchShipRectification/${this.optionSearchR}/${this.enrollment_boat_r}/${this.cSessionUser.portId}`)
          .get(`searchShipRectification/${this.optionSearchR}/${this.enrollment_boat_r}/${this.cSessionUser.portId}?api_token=${Vue.auth.getToken()}`)
          .then(res => {
            if (res.data.length > 0) {
              this.boatsR = res.data;
              this.statusSearchR = true;
            } else {
              toastr.info("No hemos encontrado aproximaciones", "Advertencia");
            }
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    mCallPhotos(b) {
      this.mShowModalSD(this.idModalL);
      this.mGetPhoto(b.id_boat);

      setTimeout(() => {
        this.mCloseModalSD(this.idModalL);
        this.mShowModalSD(this.idModalPhotos);
      }, 1000);
    },
    mShowBoat(b) {
      this.mShowModalSD(this.idModalL);
      this.nameBoat = b.name_boat;
      this.mGetBoat(b.id_boat);
      this.mGetPhoto(b.id_boat);
      setTimeout(() => {
        this.mCloseModalSD(this.idModalL);
        this.mShowModalSD(this.idModalBoatData);
      }, 1000);
    },
    async mGetBoat(b) {
      const ba = await axios.get(
        `allDtsShip/${b}?api_token=${Vue.auth.getToken()}`
      );
      // const ba = await axios.get(
      //   `allDtsShip/${b}`
      // );
      this.mGetOwner(b);
      let auxb = {
        old_enroll: ba.data[0].old_enroll,
        enroll: ba.data[0].enroll,
        type_port: ba.data[0].type_port,
        name_port: ba.data[0].name_port,
        name: ba.data[0].name,
        year_construction: ba.data[0].year_construction,
        material_construction: ba.data[0].material_construction,
        type_ship: ba.data[0].type_ship,
        destiny_navigate: ba.data[0].destiny_navigate,
        activity: ba.data[0].activity + " / " + ba.data[0].activity_parent,
        trb: ba.data[0].trb,
        trn: ba.data[0].trn,
        eslora: ba.data[0].eslora,
        manga: ba.data[0].manga,
        puntal: ba.data[0].puntal,
        calado: ba.data[0].calado,
        propulsion: ba.data[0].propulsion,
        expiration: ba.data[0].expiration,
        status: ba.data[0].status
      };

      this.boatActive = auxb;
    },
    async mGetOwner(id) {
      try {
        // obtener el propietario el id vs si es que existe
        const resp = await axios.get(
          `getOwnerShip/${id}?api_token=${Vue.auth.getToken()}`
        );
        // const resp = await axios.get(
        //   `getOwnerShip/${id}`
        // );

        if (resp.data.length > 0) {
          const o = {
            idvs: resp.data[0].id_vs,
            idShip: id,
            id: resp.data[0].id_property,
            type_identification: resp.data[0].id_identification,
            number_identification: resp.data[0].data_identification,
            site_expedition: resp.data[0].expedido,
            name: resp.data[0].name_property,
            direction: resp.data[0].domicilio,
            mobile: resp.data[0].celular,
            phone: resp.data[0].telefono_fijo,
            partner: resp.data[0].representante,
            nationality: resp.data[0].nacionalidad
          };
          this.ownerDetail = o;
        } else {
          const o = {
            idvs: 0,
            idShip: id,
            id: null,
            type_identification: "S/R",
            number_identification: "S/R",
            site_expedition: null,
            name: "S/R",
            direction: "S/R",
            mobile: null,
            phone: null,
            partner: null,
            nationality: null
          };
          this.ownerDetail = o;
        }
      } catch (error) {
        console.error(error);
      }
    },
    async mGetPhoto(id) {
      try {
        this.bImages = [];
        let ext;
        // let photo = await axios.get(
        // `getPhotos/${id}/N`
        // );

        let photo = await axios.get(`getPhotos/${id}/N?api_token=${Vue.auth.getToken()}`);

        photo.data.forEach(e => {
          switch (e.extention) {
            case "jpg":
              ext = "jpeg";
              break;

            case "png":
              ext = "png";
              break;
          }

          let ap = {
            id: e.id_photo,
            path: `data:image/${ext};base64,${e.path}`,
            image_principal: e.image_principal
          };
          this.bImages.push(ap);
        });

        this.bImage = this.bImages.find(e => {
          return e.image_principal === 1;
        });
        
      } catch (error) {
        console.error(error);
      }
    },
    mViewSearch(event) {
      var radios = $("input[type=radio]").parents("label");
      let radioV;
      for (let i = 0; i < radios.length; i++) {
        if ($(radios[i]).hasClass("active")) {
          radioV = $(radios[i])
            .children("input")
            .attr("value");
        }
      }
      this.optionSearchR = radioV;
    },
    mShowModalSD(idM) {
      $("#" + idM).modal("show");
    },
    mCloseModalSD(idM) {
      $("#" + idM).modal("hide");
    }
  },
  components: {
    "modal-loading": modalLoading,
    "modal-boat-data": modalBoatData,
    "modal-photos-boat": modalPhotosBoat
  }
};
</script>

<style>
.bounce-enter-active {
  animation: bounce-in 0.5s;
}
.bounce-leave-active {
  animation: bounce-in 0.5s reverse;
}
@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.5);
  }
  100% {
    transform: scale(1);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/verify/SearchBoatValidate.vue